export default class RenderOptions {
    static showDebugInfo = false;
    static showComponentCorners = true;     // Only active when showDebugInfo === true
    static showMargins = true;
}